import type { ComponentProps } from 'react';
import { type Strategy } from '@floating-ui/react';
import React from 'react';

import { buttonRounded } from '../common';
import { ButtonPropsSizeType } from '../common.type';
import { cn } from '../cn';

type SelectDropdownProps = ComponentProps<'div'> & {
  isOpen: boolean;
  strategy: Strategy;
  setFloating: (node: HTMLElement | null) => void;
  reference: React.RefObject<HTMLElement | null>;
  x: number;
  y: number;
  size?: ButtonPropsSizeType;
};

export default function SelectDropdownContainer({
  x,
  y,
  setFloating,
  strategy,
  isOpen,
  reference,
  size,
  children,
  className,
}: SelectDropdownProps) {
  return (
    <div
      style={{
        position: strategy,
        top: y ?? 0,
        left: x ?? 0,
        width: reference.current?.clientWidth,
        zIndex: 1000,
      }}
      ref={setFloating}
      className={cn(
        'z-1000 hidden max-h-[40vh] flex-col overflow-auto',
        'border border-slate-200 bg-white shadow-lg',
        'dark:border-charade-700 dark:bg-charade-950 dark:focus-within:bg-charade-800 dark:shadow-xl',
        { flex: isOpen },
        buttonRounded(size),
        className,
      )}>
      {isOpen && children}
    </div>
  );
}
